import { useEffect, cloneElement } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import ReactBreakpoints from 'react-breakpoints'
import { Button, Stack } from '@leroy-merlin-br/backyard-react-ui'

import { Shell } from 'reactShared/components/Shell'

import { Actions } from 'lmcv/redux/modules/module'
import { CarouselSkeleton } from 'lmcv/pages/NewHome/components/Carousel/Skeleton'
import { ModalContainer } from 'lmcv/containers/Modal'

import { Widget } from '../../../../components/Widget'
import { Spacing } from '../../components/Spacing'

const breakpoints = {
  mobile: 320,
  mobileLandscape: 480,
  tablet: 768,
  tabletLandscape: 1024,
  desktop: 1200,
  desktopLarge: 1500,
  desktopWide: 1920
}

function App ({ children, widget, ...props }) {
  const dispatch = useDispatch()
  const {
    get: { user, coupons, isRequest }
  } = useSelector(state => state.module, shallowEqual)

  useEffect(() => {
    dispatch(Actions.get(widget.lazyLoadingUrl))
  }, [dispatch, widget])

  const isLoyaltyMember = user.isMember

  if (!coupons.length) {
    return null
  }

  if (isRequest) {
    return (
      <Widget title="" withBackground noContentPadding>
        <Stack spacing="kilo">
          <Shell width={300} height={27} borderRadius="giga" />
          <CarouselSkeleton />
        </Stack>
      </Widget>
    )
  }

  return (
    <Widget
      title={widget.title}
      withBackground
      noContentPadding
    >
      {!isLoyaltyMember && (
        <Spacing>
          <span>
            Cupons de desconto disponíveis apenas para participantes do{' '}
            <a href="/fidelidade/como-funciona">Programa Fidelidade.</a>
          </span>
        </Spacing>
      )}

      <ReactBreakpoints breakpoints={breakpoints}>
        <ModalContainer />
        {cloneElement(children, {
          ...props
        })}
      </ReactBreakpoints>

      {!isLoyaltyMember && (
        <Spacing placement="top">
          <Button
            size="kilo"
            href={`/fidelidade?ref=fidelidade&origin=${location.href}`}
            isStretch
          >
            Participe do Programa Fidelidade e Ative
          </Button>
        </Spacing>
      )}
    </Widget>
  )
}

App.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func
  ])
}

export default App
